"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ButtonLockLockAll = /** @class */ (function (_super) {
    __extends(ButtonLockLockAll, _super);
    function ButtonLockLockAll(props) {
        return _super.call(this, props) || this;
    }
    ButtonLockLockAll.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    ButtonLockLockAll.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { icon: "lock", ghost: true, type: "primary", style: { margin: "2px", marginBottom: "7px" }, onClick: this.buttonClick.bind(this) })));
    };
    return ButtonLockLockAll;
}(React.Component));
exports.default = ButtonLockLockAll;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/buttons/ButtonLockLockAll.tsx
// module id = 201
// module chunks = 0